/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./chains.vue?vue&type=template&id=201aac40&scoped=true&"
import script from "./chains.vue?vue&type=script&lang=js&"
export * from "./chains.vue?vue&type=script&lang=js&"
import style0 from "./chains.vue?vue&type=style&index=0&id=201aac40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201aac40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDataTable,VIcon,VTextField})
